
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/powerocean-single-phase",
      function () {
        return require("private-next-pages/products/powerocean-single-phase/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/powerocean-single-phase"])
      });
    }
  